(function () {
  'use strict';

  angular.module('app').service('ServiceItemModalService', ServiceItemModalService);

  ServiceItemModalService.$inject = ['ModalService'];

  function ServiceItemModalService(ModalService) {
    var service = {
      openServiceItemFastCreateModal: openServiceItemFastCreateModal,
    };

    return service;

    ////////////////////////////

    function openServiceItemFastCreateModal(item, successCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/service-items/modals/service-item-fast-create-modal.html',
        controller: ServiceItemFastCreateModalCtrl,
        controllerAs: 'vm',
        inputs: {
          item: item,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        var preventModalClose = {
          backdrop: 'static',
          keyboard: false,
        };

        modal.element.modal(preventModalClose);
      });

      ServiceItemFastCreateModalCtrl.$inject = [
        '$element',
        'item',
        'successCallback',
        'LanguageService',
      ];
    }

    function ServiceItemFastCreateModalCtrl($element, item, successCallback, LanguageService) {
      var vm = this;

      vm.item = item;

      vm.modalTitle = 'NEW_SERVICE_ITEM';

      if (vm.item.id) {
        vm.modalTitle = 'EDIT_SERVICE_ITEM';
      }

      // Initializers
      getDefaultLanguage();

      // Methods
      vm.onSavedItem = onSavedItem;
      vm.onCanceledItem = onCanceledItem;

      function getDefaultLanguage() {
        LanguageService.getLanguages({ get: 'is_default', skip_check_role: true }).then(function (
          data
        ) {
          vm.defaultLanguage = data.items.lang;
        });
      }

      function onSavedItem(item) {
        successCallback(item);
        $element.modal('hide');
      }

      function onCanceledItem(item) {
        $element.modal('hide');
      }
    }
  }
})();
